import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CockpitAreaGate } from "@/components/cockpit/CockpitAreaGate";

export const Route = createFileRoute("/_cockpit/cockpit/fragebogen")({
  component: FragebogenLayout,
});

function FragebogenLayout() {
  // Ticket K9: Fragebögen sind ausschließlich für Agenturkunden sichtbar.
  return (
    <CockpitAreaGate area="questionnaires">
      <Outlet />
    </CockpitAreaGate>
  );
}
